import { ConditionalPartial } from '../../utils';
import { CreateConfirmatoryTestingScheduleRequestDto } from './create-confirmatory-testing-schedule.request.dto';

/**
 * DTO for updating a confirmatory testing schedule
 * All fields from CreateConfirmatoryTestingScheduleRequestDto are optional
 */
export class UpdateConfirmatoryTestingScheduleRequestDto extends ConditionalPartial(
    CreateConfirmatoryTestingScheduleRequestDto,
) {}


